/**
 * Get Unicode code point length (emoji-safe length).
 */
export function getCodePointLength(input: string): number {
    return Array.from(input).length
}

/**
 * Unicode-safe truncation by code points.
 * Prevents cutting surrogate pairs in the middle.
 */
export function safeTruncate(
    input: string,
    maxCodePoints: number,
    suffix = ''
): string {
    const codePoints = Array.from(input)
    if (codePoints.length <= maxCodePoints) return input

    const suffixLen = Array.from(suffix).length
    const truncLen = Math.max(0, maxCodePoints - suffixLen)
    return codePoints.slice(0, truncLen).join('') + suffix
}
